import { Animated, StyleSheet } from 'react-native';
import { PaginationContiner } from './paginationContainer';

const Pagination = ({ data, scrollX, index }) => {
  return (
    <PaginationContiner>
      {data.map((_, idx) => {
        const inputRange = [(idx - 0) * 100, idx * 100, (idx + 0) * 100];

        const dotWidth = scrollX.interpolate({
          inputRange,
          outputRange: [12, 30, 12],
          extrapolate: 'clamp',
        });

        const backgroundColor = scrollX.interpolate({
          inputRange,
          outputRange: ['#ccc', '#000', '#ccc'],
          extrapolate: 'clamp',
        });

        return (
          <Animated.View
            key={idx.toString()}
            style={[
              styles.dot,
              { width: dotWidth, backgroundColor },
              index >= idx && styles.dotActive,
            ]}
          >
            {/* <PaginationDot /> */}
          </Animated.View>
        );
      })}
    </PaginationContiner>
  );
};

export default Pagination;

const styles = StyleSheet.create({
  dot: {
    width: 12,
    height: 12,
    borderRadius: 6,
    marginHorizontal: 3,
    backgroundColor: '#368665',
  },
  dotActive: {
    backgroundColor: '#368665',
  },
});
